<template>
  <div class="card-area">
    <form novalidate class="md-layout" @submit.prevent="validateUser">
      <md-card class="md-layout-item md-size-50 md-small-size-100">
        <div class="md-title">Secure ID Verify</div>

        <md-card-header>
          <div class="md-title">Resend code</div>
        </md-card-header>
        <div class="md-title">We sent the code to your phone number:</div>
        <div class="value">
          <label for="first-name">{{ phoneNumber }}</label>
        </div>

        <div class="footer">
          <a @click="showDialog = true"><u>CHANGE NUMBER</u></a>
          <br />
          <a @click="showDialog_resend = true"><u>RESEND CODE</u></a>
        </div>
        <md-dialog :md-active.sync="showDialog">
          <md-dialog-title>Preferences</md-dialog-title>
          <div class="text_content">
            <h4>Set New Phone Number</h4>
            <div>
              <vue-phone-number-input v-model="phoneNumber" @update="onUpdate">
                <label>Phone Number</label>
                <span class="md-error">The last name is required</span>
              </vue-phone-number-input>
            </div>
          </div>
          <md-dialog-actions>
            <md-button class="md-primary" @click="showDialog = false"
              >Change</md-button
            >
          </md-dialog-actions>
        </md-dialog>
        <md-dialog :md-active.sync="showDialog_resend">
          <md-dialog-title>Preferences</md-dialog-title>
          <div class="text_content">
            <h4>Success Resent!</h4>
          </div>
          <md-dialog-actions>
            <md-button class="md-primary" @click="showDialog_resend = false"
              >Ok</md-button
            >
          </md-dialog-actions>
        </md-dialog>
        <md-card-content>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field>
                <label for="six-digit">Six Digit Code</label>
                <md-input
                  name="six-digit"
                  id="six-digit"
                  autocomplete="given-name"
                  v-model="form.sixcode"
                />
              </md-field>
            </div>
          </div>
        </md-card-content>

        <md-card-actions>
          <md-button class="md-primary" @click="Gophoto">Next</md-button>
        </md-card-actions>
      </md-card>
    </form>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";

export default {
  name: "ResendCode",
  props: {
    msg: String,
  },
  component: {},
  mixins: [validationMixin],
  data: () => ({
    form: {
      sixcode: null,
    },
    phoneNumber: "+1 419 889 78756",
    showDialog: false,
    showDialog_resend: false,
  }),

  mounted() {},
  methods: {
    Gophoto() {
      this.$router.push({ name: "TakePhotoPrepare" });
    },
    saveUser() {},
    onUpdate(payload) {
      this.phoneResult = payload;
    },
  },
};
</script>

<style lang="css" scoped>
/* .md-progress-bar {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
}

.md-card-actions {
  flex-direction: column;
}

.md-card-actions .md-button {
  margin-top: 20px !important;
  padding: 10px;
}
.footer {
  margin-top: 20px;
  padding: 10px;
  font-size: 120%;
}

.md-card {
  display: inline-block;
  padding: 20px;
}

.card-area {
  align-items: center;
  justify-content: center;
  background: #ddd;
}

.md-primary {
  background-color: green;
  color: white !important;
}

.md-layout-item.md-size-50 {
  min-width: 80%;
  max-width: 70%;
} */
</style>
